import React from 'react';
import { stats } from '../data/religione';
export function StatsBar() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100" data-id="element-272" data-mp="1tai1x90mmpqa">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-12" data-id="element-273" data-mp="1t8dpu3skqkex">
        <h2 className="shrink-0 font-serif text-2xl italic leading-tight text-red-700 lg:w-44" data-id="element-274" data-mp="1odhyz6z2q33e">
          Il pacchetto completo in numeri
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:mt-0 lg:flex-1 lg:grid-cols-5" data-id="element-275" data-mp="1edha75ifqurt">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-slate-900/15 pl-5" data-id="element-276" data-mp="19kxv2443nrkw">
              <dt className="mt-3 text-sm leading-snug text-slate-900/70" data-id="element-277" data-mp="15l5n9tmj5pgl">{stat.label}</dt>
              <dd className="font-serif text-6xl leading-none tracking-tight text-slate-900" data-id="element-278" data-mp="10ndxb55g4df1">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}